module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/katayamazu_onsen_soyu-d489714615900bcefc5f1315c820ed79.jpg";